import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { WorkScheduleRoutingModule } from './work-schedule-routing.module';
import { SharedModule } from '../../../../shared/shared.module';
import { WorkScheduleDetailsComponent } from './work-schedule-details/work-schedule-details.component';
import { WorkScheduleWeekComponent } from './shared/work-schedule-week/work-schedule-week.component';
import { WorkScheduleCreateComponent } from './work-schedule-create/work-schedule-create.component';
import { WorkScheduleEditComponent } from './work-schedule-edit/work-schedule-edit.component';
import { WorkScheduleFormContentComponent } from './shared/work-schedule-form-content/work-schedule-form-content.component';

@NgModule({
  declarations: [
    WorkScheduleDetailsComponent,
    WorkScheduleWeekComponent,
    WorkScheduleCreateComponent,
    WorkScheduleEditComponent,
    WorkScheduleFormContentComponent,
  ],
  imports: [CommonModule, SharedModule, WorkScheduleRoutingModule],
})
export class WorkScheduleModule {}
